module.exports = function () {
    $( document ).ready(function() {
        var helper = require('./helper');
        const countGuardians = 1;

        $(document).on('click', '*[id^="assign-button"]', function (event) {
            event.preventDefault();

            let showModalIfNoSpaceInProperty = require('./helpers/assign-helper.js').showModalIfNoSpaceInProperty,
                propertyId = window.location.href.split("/").pop();

            showModalIfNoSpaceInProperty(propertyId, countGuardians);
        });

        var guardians = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.value);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/guardians/search/%QUERY",
                wildcard: '%QUERY'
            }
        });

        /** Run TypeAhead */
        $('.typeahead').typeahead(null, {
            highlight: true,
            limit: 20,
            minLength: 1,
            valueKey: 'id',
            displayKey: function(guardian) {
                return guardian.user.first_name + ' ' + guardian.user.last_name + ' (' + guardian.unique_guardian_number + ')' ;
            },
            name: 'guardians',
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find guardians', '</strong></div>'].join('\n'),
                suggestion: function (guardian) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + guardian.user.first_name + ' ' + guardian.user.last_name + ' (' + guardian.unique_guardian_number + ')' + '</strong></p>';
                }
            },
            source: guardians
        });

        /** Bind selected event */
        $('#guardian').bind('typeahead:select', function (ev, guardians) {
            $('#selectedGuardians').val(guardians.id);
        });

    });
}();
